import { GET_UNIT_RATES, GET_UNIT_RATES_RESPONSE, RESET } from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  data: {
    unitRatesList: {
      items: [],
    },
    unitRate: null,
    searchQuery: null,
    range: { start: 0, end: 25 },
  },
};

// State
export default (state = initialState, action) => {
  var data = state.data;
  switch (action.type) {
    case RESET:
      return Object.assign({}, initialState);
    case GET_UNIT_RATES:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_UNIT_RATES_RESPONSE:
      data.unitRatesList.items = action.unitRates;
      return {
        ...state,
        data: data,
        error: action.error,
        isLoading: false,
      };
    default:
      return {
        ...state,
      };
  }
};
